/**
 * Subscriptions store.
 *
 */

 import { Module, Action, getModule } from 'vuex-module-decorators';
 import PageBaseModule from '@/store/page';
 import store from '@/store';
 import PageEntity from '@/store/pageEntity';
 import { getList } from '@/api/crud';
 import ResponseHandlerModule from '@/store/modules/responseHandler';

 import { SubscriptionTypes } from '@/models/subscriptionTypes';
 import filterModel from '@/store/subscriptions/filterModel';
 import SubscriptionTypesFilter from '@/store/subscriptionTypes/filterEntity';
 import { Filter } from '@/types/filter/filter';
import { TableApiInterface } from '@/types/page/table';

enum AvailableEnum {
    YES = 'Да',
    NO = 'Нет',
}

 @Module({ dynamic: true, store, name: SubscriptionTypes.moduleName, namespaced: true })
 class SubscriptionTypesModule extends PageBaseModule {
     filter: Filter;

     constructor(module: SubscriptionTypesModule) {
         super(module);

         const page = new PageEntity();
         page.setModuleName(SubscriptionTypes.moduleName);
         page.setTitle(SubscriptionTypes.listTitle);
         page.setTitleAdd(SubscriptionTypes.createTitle);
         page.setTitleEdit(SubscriptionTypes.editTitle);
         page.values.actionPagination = 'subscriptionTypes/updatePage';
         page.values.actionPageAmountItems = 'subscriptionTypes/updatePageAmountItems';
         page.values.pageAmountItems = 50;
         this.pageSettings = page.values;
         this.pageSettings.routeName = `${SubscriptionTypes.moduleName}_edit`;
         this.pageSettings.routeParam = `${SubscriptionTypes.moduleName}Id`;

         const filter = new filterModel();
         this.filter = getModule(SubscriptionTypesFilter);
         this.filter.setFilterName('SubscriptionTypesFilter');
         this.filter.setTemplateClassName('template-lg directory-filters');
         this.filter.setFilterModel(filter.filterModel);
         this.filter.setFilterHandlers(filter.filterHandlers);
     }

     @Action({ rawError: true })
     async init() {
         await this.getList();
     }

     @Action({ rawError: true })
     async getList() {
         try {
             const sort = await this.getSortForRequest();
             const result = await getList(SubscriptionTypes.apiPrefix,
                 {
                     page: this.pageSettings.pageCurrent,
                     items: this.pageSettings.pageAmountItems,
                 },
                 sort,
                 this.filter.filterSettings.filter,
             );

             await this.context.dispatch('setList', await this.processList(result.table));
         } catch (clientError: any) {
             const error = clientError.response.data;

             ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

             await this.context.dispatch('updatePage', 1);
         }
     }

     @Action({ rawError: true })
     processList(table: TableApiInterface) {
        table.titles = table.titles.map(title => {
            if (title.id === 'isAvailable' || title.id === 'isCheckup') {
                title.visible = true;
            }

            return title;
        });
        table.rows = table.rows.map(row => {
            row.isAvailable = row.isAvailable ? AvailableEnum.YES : AvailableEnum.NO;
            row.isCheckup = row.isCheckup ? AvailableEnum.YES : AvailableEnum.NO;

            return row;
        });

        return table;
     }
 }

 export default getModule(SubscriptionTypesModule);
